<template>
  <UModal
    v-bind="{ ...props, ...$attrs }"
    class="p-modal"
    @update:open="emit('update:open', $event)"
    @enter="emit('enter')"
    @after:enter="emit('after:enter')"
    @leave="emit('leave')"
    @after:leave="emit('after:leave')"
    @close:prevent="emit('close:prevent')"
  >
    <template v-if="slots.default" #default="slotProps"><slot v-bind="slotProps" /></template>
    <template v-if="slots.content" #content="slotProps"
      ><slot name="content" v-bind="slotProps"
    /></template>
    <template v-if="slots.header" #header="slotProps"
      ><slot name="header" v-bind="slotProps"
    /></template>
    <template v-if="slots.title" #title><slot name="title" /></template>
    <template v-if="slots.description" #description><slot name="description" /></template>
    <template v-if="slots.actions" #actions><slot name="actions" /></template>
    <template v-if="slots.close" #close="slotProps"
      ><slot name="close" v-bind="slotProps"
    /></template>
    <template v-if="slots.body" #body="slotProps"><slot name="body" v-bind="slotProps" /></template>
    <template v-if="slots.footer" #footer="slotProps"
      ><slot name="footer" v-bind="slotProps"
    /></template>
  </UModal>
</template>

<script setup lang="ts">
import UModal, {
  type ModalProps,
  type ModalEmits,
  type ModalSlots
} from "@nuxt/ui/components/Modal.vue"

const props = withDefaults(defineProps<ModalProps>(), {
  open: undefined,
  defaultOpen: undefined,
  modal: true,
  unmountOnHide: true,
  overlay: true,
  transition: true,
  fullscreen: false,
  scrollable: false,
  portal: true,
  close: true,
  dismissible: true
})
const emit = defineEmits<ModalEmits>()
const slots = defineSlots<ModalSlots>()
defineOptions({ inheritAttrs: false })
</script>
